import {
	ADD_USERS
} from "../constants"

const initialState = {
	users: []
};

export const UsersReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
		case ADD_USERS :
			action.payload.users.forEach( ( user ) => {
				state = {
					...state,
					users: [
						...state.users,
						{
							key: user.key,
							name: user.val().name,
							image: user.val().author_image
						}

					]
				}
			} );
			break;
		default:

			break;

	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/users.js